import { inject, observer } from 'mobx-react'
import * as React from 'react'
import { ILayoutStore } from 'src/store/LayoutStore'
import { IUserStore } from 'src/store/UserStore'
import CardButton from '../CardButton/CardButton'
import Drawer from '../Drawer/Drawer'
import ValidateButton from '../ValidateButton/ValidateButton'
import EditResponse from '../EditResponse/EditResponse'
import { IStepState } from '../Step/Step'
import { tag } from '../../services/ATInternetService'
import IddleMessage from '../IddleMessage/IddleMessage'

export interface IStepPriceState {
  selectedValue: number
}

interface IStepPriceProps {
  LayoutStore?: ILayoutStore
  UserStore?: IUserStore
  stepState: IStepState
  onChange: (change: object) => void
  onChangeState: (change: object) => void
  onResetAnswer: () => void
  stepCount: number
}

@inject('UserStore', 'LayoutStore')
@observer
class StepPrice extends React.Component<IStepPriceProps, IStepPriceState> {
  public constructor(props: IStepPriceProps) {
    super(props)
    this.state = {
      selectedValue: this.props.UserStore!.price || 0,
    }

    if (
      this.props.stepCount < this.props.LayoutStore!.currentStep &&
      this.props.UserStore!.price === null
    ) {
      this.props.onChangeState({ skipped: true })
    }
  }

  public render() {
    return (
      <div>
        <div className="Row Row--mw500">
          <label htmlFor="price">
            A votre avis, la semaine dernière, combien avez-vous dépensé pour acheter de l’alcool ?
          </label>
        </div>

        {this.props.stepState.isAnswered && !this.props.stepState.skipped && (
          <div className="Row Row--center">
            <CardButton variant="money" label={`${this.props.UserStore!.price}`} />

            <EditResponse functionEdit={this.props.onResetAnswer} />
          </div>
        )}

        {!this.props.stepState.isAnswered && !this.props.stepState.skipped && (
          <>
            <Drawer>
              <div className="Drawer-price">
                <label htmlFor="price" className="Drawer-priceContainer">
                  <input
                    id="price"
                    onChange={this.validateSelection}
                    type="number"
                    min="0"
                    max="9999"
                    value={'' + this.state.selectedValue}
                  />
                  <span>€</span>
                </label>
              </div>
            </Drawer>
            <div className="skippable control-color-wrapper">
              <CardButton
                label="Passez cette question"
                onClick={this.skipQuestion}
                variant="skipit"
              />
            </div>
          </>
        )}

        {!this.props.stepState.isAnswered &&
          this.props.stepState.needValidation &&
          !this.props.stepState.skipped && (
            <div className="control-color-wrapper">
              <ValidateButton onClick={this.setPrice} />
            </div>
          )}

        {this.props.stepState.skipped && (
          <>
            <div className="Row Row--center Row--ml-3">
              <CardButton
                label="Répondre à cette question"
                onClick={this.unSkipQuestion}
                variant="skipit"
              />
            </div>
            <div className="Row Row--mw500">
              <p>C'est noté !</p>
            </div>
          </>
        )}

        {!this.props.stepState.isAnswered &&
          !this.props.stepState.needValidation &&
          !this.props.stepState.skipped && (
            <div className="control-color-wrapper">
              <IddleMessage iddleMessageLabel="Définissez votre dépense (entre 1 et 9 999€)" />
            </div>
          )}
      </div>
    )
  }

  private validateSelection = (e: React.ChangeEvent<HTMLInputElement>) => {
    const text = e.target.value.replace(/\D/, '')
    let value = parseInt(text, 10)

    value = value > 9999 ? 9999 : value
    value = value < 1 ? 1 : value

    if (e.target.value === '') {
      value = 0
    }

    this.setState({ selectedValue: value })

    this.props.onChange({ needValidation: value !== null && value !== 0 })
  }

  private setPrice = () => {
    tag.sendPage({ elem: this, name: 'budget_ok', chapter1: 'Questionnaire' })

    this.props.UserStore!.setPrice(this.state.selectedValue)
    this.props.onChange({ isAnswered: true, needValidation: false })
  }

  private skipQuestion = () => {
    tag.sendPage({ elem: this, name: 'budget_skip', chapter1: 'Questionnaire' })
    this.props.onChange({ skipped: true })
    this.props.UserStore!.setPrice(null)
  }

  private unSkipQuestion = () => {
    this.props.onChange({ skipped: false })
  }
}

export default StepPrice



// WEBPACK FOOTER //
// ./src/components/StepPrice/StepPrice.tsx